module.exports = __webpack_public_path__ + "img/device-status-activated.2c2de83a.svg";